import React from 'react'
// import { ReactComponent as CaloriesIcon } from '../../../../assets/icons/flame.svg'
import { ReactComponent as CaloriesIcon } from '../../../../assets/v2/icons/icon-activity-calories-white.svg'
import { ReactComponent as HeartIcon } from '../../../../assets/icons/heart.svg'
// import { ReactComponent as StepsIcon } from '../../../../assets/icons/steps.svg'
import { ReactComponent as StepsIcon } from '../../../../assets/v2/icons/icon-activity-steps-white.svg'
import { formatThousands } from '../../../../common/helpers/translations'
import { CustomType, ProgressType } from '../../../../services/api.types'
import { ActivityView } from '../../../../views/Activity/store/ActivityReducer'
import { Tooltip } from '../../../Tooltip/Tooltip'
import './ProgressCell.scss'
import { ReactComponent as MinutesIcon } from '../../../../assets/v2/icons/icon-activity-minutes.svg'
import { msgid, ngettext, t } from 'ttag'
import { isDistanceType, isPersistenceType } from '../../../../common/helpers/challenges'
import { customUnits, getCustomUnitText } from '../../../../services/CustomTypes'
import YumBlueTooltip from '../../../YumBlueTooltip/YumBlueTooltip'

export interface IProgressCellProps {
  /**
   * Number of calories burned in total.
   */
  caloriesTotal?: number
  /**
   * Number of intensive minutes in total.
   */
  intensiveMinutesTotal?: number
  /**
   * Number of steps in total.
   */
  stepsTotal?: number
  /**
   * Type of the current goal.
   */
  progressType?: ProgressType
  /**
   * Progress completion percent
   */
  progress?: number

  /**
   * Progress description
   */
  description?: string

  /**
   * Activity formula target
   */
  activityFormulaTarget?: number

  /**
   * Persistence total
   */
  persistenceTotal?: number

  customType?: CustomType | null
  customUnit?: string | null

  /**
   * Activity view for leaderboard context.
   * Tooltip is only shown for individual or collective views.
   */
  activityView?: ActivityView | string

  /**
   * Raw percentage value for display (always available for activity index).
   * Used when progress is undefined but we still need to show the value.
   */
  percentage?: number
}

interface IProgressCellState {
  isTooltipVisible: boolean
}

export class ProgressCell extends React.PureComponent<IProgressCellProps, IProgressCellState> {
  /*state = { isTooltipVisible: false }
  tooltipTimer: any

  componentWillUnmount() {
    this.clearTimer()
  }*/

  hasDescription = () => {
    if (this.props.description) {
      return <p className="progress-cell__description">{this.props.description}</p>
    }

    return null
  }

  /*toggleTooltip = () => {
    this.state.isTooltipVisible ? this.hideTooltip() : this.showTooltip()
  }

  showTooltip = () => {
    this.clearTimer()

    this.setState({ isTooltipVisible: true }, () => {
      this.tooltipTimer = setTimeout(() => {
        this.hideTooltip()
      }, 3000)
    })
  }

  hideTooltip = () => {
    this.clearTimer()

    this.setState({ isTooltipVisible: false })
  }

  clearTimer = () => {
    if (this.tooltipTimer) {
      clearTimeout(this.tooltipTimer)
    }
  }*/

  BEM = () => {
    const classArr = ['progress-cell']
    const { progress, activityFormulaTarget } = this.props
    const target = activityFormulaTarget || 100

    if (progress && progress >= target) {
      classArr.push('progress-cell--active')
    }

    if (progress && progress >= target) {
      classArr.push('progress-cell--overflow')
    }

    // Add right alignment class when there's no progress bar
    if (progress === undefined) {
      classArr.push('progress-cell--no-progress')
    }

    return classArr.join(' ')
  }

  // Only allow tooltip for individual or collective leaderboard views.
  // This keeps the UI consistent across different ranking modes.
  shouldShowActivityTooltip = () => {
    const { activityView } = this.props
    return activityView === ActivityView.INDIVIDUAL || activityView === ActivityView.COLLECTIVE
  }

  renderAllProgressCell() {
    const { caloriesTotal, intensiveMinutesTotal, stepsTotal, progress, percentage } = this.props
    //const { isTooltipVisible } = this.state
    const displayValue = progress ?? percentage

    const shouldShowTooltip = this.shouldShowActivityTooltip()

    return (
      <div className="progress-cell__value">
        {/*<Tooltip isTooltipVisible={isTooltipVisible}>
          <HeartIcon className="progress-cell__tooltip-icon" />
          <span>{formatThousands(intensiveMinutesTotal || 0)}</span>
          <span className="progress-cell__tooltip-content-separator"></span>
          <StepsIcon className="progress-cell__tooltip-icon progress-cell__tooltip-icon--steps" />
          <span>{formatThousands(stepsTotal || 0)}</span>
          <span className="progress-cell__tooltip-content-separator"></span>
          <CaloriesIcon className="progress-cell__tooltip-icon progress-cell__tooltip-icon--calories" />
          <span>{formatThousands(caloriesTotal || 0)}</span>
        </Tooltip>*/}
        {shouldShowTooltip ? (
          <YumBlueTooltip
            title={
              <>
                <HeartIcon className="progress-cell__tooltip-icon" />
                <span className="progress-cell__tooltip-span">{formatThousands(intensiveMinutesTotal || 0)}</span>
                <span className="progress-cell__tooltip-content-separator"></span>
                <StepsIcon className="progress-cell__tooltip-icon progress-cell__tooltip-icon--steps" />
                <span className="progress-cell__tooltip-span">{formatThousands(stepsTotal || 0)}</span>
                <span className="progress-cell__tooltip-content-separator"></span>
                <CaloriesIcon className="progress-cell__tooltip-icon progress-cell__tooltip-icon--calories" />
                <span className="progress-cell__tooltip-span">{formatThousands(caloriesTotal || 0)}</span>
              </>
            }
            placement="left"
            enterTouchDelay={50}
            leaveTouchDelay={3000}
            arrow
            PopperProps={{
              container: document.getElementById('content'),
              //disablePortal: true,
            }}
          >
            <div className={displayValue === undefined ? 'text-right' : ''}>
              <span>{displayValue}</span> <span style={{ fontSize: '0.75rem' }}>%</span>
            </div>
          </YumBlueTooltip>
        ) : (
          <div className={displayValue === undefined ? 'text-right' : ''}>
            <span>{displayValue}</span> <span style={{ fontSize: '0.75rem' }}>%</span>
          </div>
        )}
      </div>
    )
  }

  renderCustomProgressCell() {
    const { persistenceTotal, customType, customUnit, progress } = this.props
    const unit = getCustomUnitText(customType, customType, customUnit)
    const isDistance = isDistanceType(customType)
    return (
      <div className="progress-cell__value">
        <div className={progress === undefined ? 'text-right' : ''}>
          <span>
            {formatThousands(persistenceTotal || 0, isDistance ? 2 : undefined)} {unit}
          </span>
        </div>
      </div>
    )
  }

  renderSpecificProgressCell() {
    const {
      progress,
      progressType,
      stepsTotal,
      caloriesTotal,
      intensiveMinutesTotal,
      customType,
      persistenceTotal,
      customUnit,
    } = this.props
    //const { isTooltipVisible } = this.state
    const Icon =
      progressType && [ProgressType.CALORIES, ProgressType.COLLECTIVE_CALORIES].includes(progressType)
        ? CaloriesIcon
        : progressType && [ProgressType.STEPS, ProgressType.COLLECTIVE_STEPS].includes(progressType)
          ? StepsIcon
          : MinutesIcon
    const isCollectiveCustom = progressType === ProgressType.COLLECTIVE_CUSTOM
    //console.log('isCollectiveCustom', isCollectiveCustom)
    const isDistance = isDistanceType(customType)
    const value =
      progressType && [ProgressType.CALORIES, ProgressType.COLLECTIVE_CALORIES].includes(progressType)
        ? caloriesTotal
        : progressType && [ProgressType.STEPS, ProgressType.COLLECTIVE_STEPS].includes(progressType)
          ? stepsTotal
          : isCollectiveCustom
            ? persistenceTotal
            : intensiveMinutesTotal
    const unit = getCustomUnitText(customType, customType, customUnit) as string
    const shouldShowTooltip = this.shouldShowActivityTooltip()
    const valueContent = (
      <div className={progress === undefined ? 'text-right' : ''}>
        <span>{formatThousands(value || 0, isDistance ? 2 : 0)}</span>
        {isCollectiveCustom ? (
          ' ' + unit
        ) : (
          <Icon className="progress-cell__tooltip-icon progress-cell__tooltip-icon--steps-blue" />
        )}
      </div>
    )

    return (
      <div className="progress-cell__value">
        {/*{progress !== undefined && (
          <Tooltip isTooltipVisible={isTooltipVisible}>
            <span>{progress}</span> <span style={{ fontSize: '0.75rem' }}>%</span>
          </Tooltip>
        )}*/}

        {progress !== undefined && shouldShowTooltip ? (
          <YumBlueTooltip
            title={
              <>
                <span>{progress}</span> <span style={{ fontSize: '0.75rem' }}>%</span>
              </>
            }
            placement="left"
            enterTouchDelay={50}
            leaveTouchDelay={3000}
            arrow
            PopperProps={{
              container: document.getElementById('content'),
              //disablePortal: true,
            }}
          >
            {valueContent}
          </YumBlueTooltip>
        ) : (
          valueContent
        )}
      </div>
    )
  }

  renderPersistenceProgressCell(progress: number | undefined) {
    const { persistenceTotal } = this.props
    const days = persistenceTotal || 0
    return (
      <div className="progress-cell__value">
        <div className={progress === undefined ? 'text-right' : ''}>
          {persistenceTotal} <span style={{ fontWeight: 'normal' }}>{ngettext(msgid`day`, `days`, days)}</span>
        </div>
      </div>
    )
  }

  render() {
    const { progressType, progress, activityFormulaTarget } = this.props

    let calculatedProgress = progress !== undefined ? progress : false
    if (progress !== undefined && progressType !== ProgressType.STEPS && activityFormulaTarget) {
      calculatedProgress = Math.round(progress * (100 / activityFormulaTarget))
    }

    const isPersistenceChallenge = progressType && isPersistenceType(progressType)
    /*console.log(
      !progressType || progressType === ProgressType.ALL ? 'renderAllProgressCell' : '',
      progressType === ProgressType.CUSTOM ? 'CUSTOM' : '',
      isPersistenceChallenge ? 'isPersistenceChallenge' : 'legacy',
    )*/
    return (
      <div
        className={this.BEM()}
        /*onClick={progressType ? this.toggleTooltip : undefined}
        onMouseEnter={progressType ? this.showTooltip : undefined}*/
      >
        {!progressType || progressType === ProgressType.ALL
          ? this.renderAllProgressCell()
          : progressType === ProgressType.CUSTOM
            ? this.renderCustomProgressCell()
            : isPersistenceChallenge
              ? this.renderPersistenceProgressCell(progress)
              : // This is only shown for legacy (steps etc) challenges
                this.renderSpecificProgressCell()}
        {progress !== undefined && (
          <>
            <div className="progress-cell__goal">
              <div
                className="progress-cell__progressbar"
                style={{
                  width: `${calculatedProgress}%`,
                }}
              />
            </div>
          </>
        )}
        {this.hasDescription()}
      </div>
    )
  }
}
